import { Link } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";

export default function NotFound() {
  useSEO({
    title: "页面未找到 - 星光传媒",
    description: "抱歉，你访问的页面不存在或已被移动。返回星光传媒首页，继续浏览影视作品与资讯。",
  });

  return (
    <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
      <p className="font-heading text-6xl font-bold text-accent-500 md:text-8xl">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        页面走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的页面不存在或已被移动。不妨回到首页，看看最新的影视作品与行业资讯吧。
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
        >
          返回首页
        </Link>
        <Link
          to="/news/industry"
          className="whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-semibold text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
        >
          查看影视资讯
        </Link>
      </div>
    </div>
  );
}